import { Component, ViewEncapsulation } from '@angular/core';
import { CommonModule } from '@angular/common';
import { TranslateModule } from '@ngx-translate/core';

import { StudentSessionsTabComponent } from '../../../shared/tables/student-sessions-tab/student-sessions-tab.component';

/**
 * Suivi des élèves, vue administration.
 *
 * <p>Une coquille, volontairement. La table des copies existait déjà pour le
 * professeur dans <c>shared/tables/</c> — la recopier ici aurait garanti qu'un
 * jour les deux écrans ne diraient plus la même chose du même élève. Elle est
 * donc réutilisée telle quelle, avec deux paramètres : l'étendue, qui décide
 * de la route interrogée et fait apparaître les facettes, et la racine des
 * liens de détail, qui menaient jusqu'ici dans la coquille du professeur.</p>
 *
 * <p>Le rapport de diagnostic, lui, n'avait rien à construire : sa route porte
 * déjà <c>roles: ['supervisor']</c> et le serveur laisse passer un jeton sans
 * claim d'élève. Il lui manquait un chemin d'accès, posé depuis la fiche
 * élève.</p>
 */
@Component({
  selector: 'app-admin-student-following',
  standalone: true,
  imports: [CommonModule, TranslateModule, StudentSessionsTabComponent],
  templateUrl: './admin-student-following.component.html',
  styleUrl: './admin-student-following.component.css',
  encapsulation: ViewEncapsulation.None,
})
export class AdminStudentFollowingComponent {}
